import React from 'react'
import { Helmet } from 'react-helmet'
import { HowTo } from '../../../components'
import { HowToData } from '../../Developers/Node/data'
import Statistics from '../../Home/Statistics'
import Feature from './Feature'

const Protfolio = () => {

  let portfolioData = {
    title1: 'Redefining Businesses with',
    title2: 'Software Development',
    desc: 'A leading software development company with vast experience.'
  }

  return (
    <div>

      <Helmet >
        <title> CodeZone | Portfolio</title>
      </Helmet>

      <div className=' pt-[52px] md:pt-[60px]'>
        <div className="dark:bg-gray-900 transition-all duration-700">
          <Feature />
        </div>
        <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
          <HowTo data={HowToData} portfolioData={portfolioData} />
        </div>
        <div className="dark:bg-gray-900 transition-all duration-700">
          <Statistics />
        </div>
      </div>
    </div>

  )
}

export default Protfolio